
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {DataConversion} from "../../utils/util";
import BScroll from 'better-scroll'

export default {
name: "TuanCustomList",
components: {
Cell,
Group
},
data() {
return {
shopId: this.$route.params.shopId,
page: 1,
pageSize: 50,
tableData: [],
customTypeMap: new Map([[1, "年会"], [2, "团建"], [3, "聚会"], [4, "培训"], [5, "其他"],
[31, "参观"], [32, "参观+讲解"], [33, "红色剧本体验"],
[61, "塔熊"], [62, "雄塔"]]),
orderStatusMap: new Map([[0, "已取消"], [1, "提交(待确认)"], [2, "已确认"], [3, "已完成"], [100, "删除"]]),
refreshLoading: false,
refreshReturn: false,
refreshReturnMsg: "",
moreReturnMsg: "",
moreLoading: false,
moreReturn: false,
}
},
created() {
this.initPageData()
},
mounted() {
this.$nextTick(() => {
this.scroll = new BScroll(this.$refs.scroll, {
mouseWheel: true,
click: true, //默认为false 不可点击
scrollbar: {
fade: false,
interactive: true
},
probeType: 3,
pullDownRefresh: {
threshold: 50, // 当下拉到超过顶部 50px 时，触发 pullingDown 事件
stop: 20 
},
pullUpLoad: {
threshold: -5 
}
})


this.scroll.on('pullingDown', () => {
this.refreshReturn = false
this.refreshLoading = true

let toLoadPage = 1;
this.fetchData(toLoadPage, (newData) => {
this.refreshLoading = false
this.refreshReturn = true
if (newData.data.code == 0) {
let {total: resTotal, rows: resRow} = newData.data.data
if (resRow.length < 1) {
this.refreshReturnMsg = "没有更新的数据啦"
} else {
this.tableData = resRow;
this.refreshReturnMsg = "刷新成功"
this.refreshReturn = false
this.page = 2
}
} else {
this.refreshReturnMsg = newData.data.msg
}
this.scroll.finishPullDown()

this.moreReturnMsg = ""
this.scroll.finishPullUp()
})
})


this.scroll.on('pullingUp', () => {
this.moreLoading = true
this.moreReturn = false
this.moreReturnMsg = ""
this.fetchData(this.page + 1, (newData) => {
this.moreLoading = false
this.moreReturn = true
if (newData.data.code == 0) {
let {total: resTotal, rows: resRow} = newData.data.data
if (resRow.length < 1) {
this.moreReturnMsg = "没有更多数据了"
} else {
resRow.forEach(item => {
this.tableData.push(item)
})
this.moreReturnMsg = '加载成功'
this.moreReturn = false
this.page++

this.scroll.finishPullUp()
}
} else {

this.moreReturnMsg = '请求异常，请稍后重试'
}
})
})
})
},
methods: {
initPageData() {
this.getCustomList()
},
getCustomList() {
let _this = this;
let shopId = _this.shopId
_this.axios.post('/v1/shop/' + shopId + '/custom/tuan/GET_CUSTOMIZE_ORDER_LIST', {
currentPage: _this.page,
pageSize: _this.pageSize
}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

let {total: resTotal, rows: resRow} = response.data.data






_this.tableData = resRow;

}
}).catch(function (response) {
console.log(response);
});
},

getMapValue: DataConversion.getMapValueByKey,

fetchData(toLoadPage, callback) {
let shopId = this.shopId
let _this = this;
_this.axios.post('/v1/shop/' + shopId + '/custom/tuan/GET_CUSTOMIZE_ORDER_LIST', {
currentPage: toLoadPage,
pageSize: _this.pageSize
}, {
headers: {}
}).then(function (response) {
callback && callback(response);
}).catch(function (response) {

});
}
}
}



// WEBPACK FOOTER //
// ./src/components/tuan/TuanCustomList.vue